import { useNavigate } from "react-router-dom";
import { usePopup } from "../Components/Popup/TabPopupContext";

export default function useCustomNavigate() {
  const navigate = useNavigate();
  const { openPopup } = usePopup();

  const customNavigate = (to, options) => {
    const data = JSON.parse(localStorage.getItem("pageHistory")) || [];
    if (data.length >= 15) {
      openPopup("Tab limit of 5 has been reached. Kindly close one tab to continue browsing");
      return;
    }
    console.log("Custom navigation triggered:", to);
    navigate(to, options);
  };

  return customNavigate;
}
